<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fab fa-whatsapp">
            <canal></canal>
        </c-panel>
    </div>
</template>
<script>
import canal from "./canal"
export default {
    components: { canal },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Canal WhatsApp' }
}
</script>
